<template>
    <collapsible-card :title="'Time Spent at Leases in the Last 90 Days'" ref="cCard" v-show="showHistograms">
        <div class="cardContent histogramList">
            <div>
                <div class="histogramMainInfo">
                    <p class="dataEmphasis">Lease Histogram</p>
                </div>
                <div class="chartContent">
                    <div class="chart histogram">
                        <div id="leaseHistograms"></div>
                    </div>
                </div>
            </div>
        </div>
    </collapsible-card>
</template>

<script>
import Highcharts from 'highcharts';
import CollapsibleCard from '../CollapsibleCard.vue';

export default {
    name: 'vessel-histogram-leases',
    components:{
        CollapsibleCard
    },
    data: () => ({
        showHistograms: false,
    }),
    methods: {
        reset: function() {
            var globv = this;
            globv.showHistograms = false;
        },
        createChart: function(leaseHisto) {
            var globv = this;
            let series = [];

            for (let leaseObj of leaseHisto) {
                let totalMin = 0;
                let tempData = [];
                for (let l of leaseObj['bins']) {
                    tempData.push([l['date'], l['minuteDelta'], leaseObj['leaseNum'], leaseObj['operator'], leaseObj['block']])
                    
                    totalMin += l['minuteDelta'];
                }
                series.push({
                    name: leaseObj['block'],
                    totalMin: totalMin,
                    data: tempData
                });
            }

            series.sort((a, b) => (a.totalMin > b.totalMin) ? -1 : 1);

            Highcharts.theme = {
                colors: [
                    "#ED4553",
                    "#2B76DE",
                    "#6DDF76",
                    "#FC7C73",
                    "#409BC9",
                    "#F8B18B",
                    "#86E1E4",
                    "#F7D8BB",
                    "#CDEAE5",
                    "#F1FAEE"
                ]
            }

            Highcharts.setOptions(Highcharts.theme);

            Highcharts.chart('leaseHistograms', {
                chart: {
                    type: 'column',
                    backgroundColor: '#22293d'
                },
                credits: {
                    enabled: false,
                    credits: false
                },
                title: {
                    text: null
                },
                legend: {
                    enabled: true,
                    itemStyle: {
                        color: "#fff"
                    }
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        keys: ['x', 'y', 'leaseNum', 'operator', 'block']
                    },
                    column: {
                        stacking: 'normal',
                    }
                },
                tooltip: {
                    pointFormatter: function() {
                        let output = '<b style="font-size: 14px">' + this.options.leaseNum + '</b><br/>'
                        output += this.y + " minutes <br/>";
                        if (this.options.operator) {
                            output += "Operator: " + this.options.operator + "<br/>";
                        }
                        if (this.options.block) {
                            output += "Block: " + this.options.block + "<br/>";
                        }

                        return output;
                    },
                    xDateFormat: '%A, %b %d'
                },
                yAxis: {
                    title: {
                        text: "Minutes Spent",
                        style: {
                            color: "#fff"
                        }
                    },
                    gridLineColor: "#666666",
                    labels: {
                        style: {
                            color: "#fff"
                        }
                    }
                },
                xAxis: {
                    type: 'datetime',
                    crosshair: true,
                    tickInterval: 36e5 * 24, // day intervals
                    labels: {
                        style: {
                            color: "#fff"
                        },
                        format: '{value:%b %d}'
                    }
                },
                series: series
            });

            globv.showHistograms = leaseHisto.length > 0;

            globv.$refs.cCard.adjustHeight()
        }
    }
}
</script>